/**
 * Truncates a wallet or contract address to the first 4 and last 4 characters.
 * @param address - The address to truncate.
 * @returns The truncated address.
 */

export const truncateAddress = (address: string | null | undefined) => {
	if (!address || typeof address !== "string") {
		return "";
	}
	return `${address.slice(0, 4)}...${address.slice(-4)}`;
};
